import { TableCell } from "@mui/material"
import { ShowMoreState } from "./incidentSummary";
import { IOCRowStyle } from "./incidentSummary.styled";
import { convertUnixTimeToDate } from  "core/utils/dateTimeUtils";



export interface Ioc {
    message: IocInner;
}

export interface IocInner {
    time: string;
    ioc_from: string;
    type: string;
    firstSeen: string;
    risk_score: number;
    value: string;
}

export interface IocRowProps {
    t: any;
    row: Ioc
    index: number
    showMore: ShowMoreState;
    handleClick: (string) => void;
    theme: any;
}

/**
 * The AI team had provided a results key with more information on the row.
 * This key was removed at the last minute
 */
export default function IocRow({t, row, index, showMore, handleClick, theme}: IocRowProps) {
    return(<IOCRowStyle
                key={`ioc-row-${index}`}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
        {
            row.message.ioc_from === "N/A" ? <>
                <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{"N/A"}</TableCell>
                <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{"N/A"}</TableCell>
                <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{"N/A"}</TableCell>
                <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{"N/A"}</TableCell>
                <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{"N/A"}</TableCell>
                <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{"N/A"}</TableCell>
            </>
            :
            <>
                <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{convertUnixTimeToDate(Number(row.message.time))}</TableCell>
                <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{row.message.ioc_from}</TableCell>
                <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{row.message.type}</TableCell>
                <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{convertUnixTimeToDate(Number(row.message.firstSeen))}</TableCell>
                <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{row.message.risk_score.toFixed(2)}</TableCell>
                <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{row.message.value}</TableCell>
            </>
        }
    </IOCRowStyle>);
}

// Changes a day before release
// export interface Ioc {
//     source: string;
//     message: IocMessage;
// }

// export interface IocMessage {
//     pager: boolean;
//     queryValue: string;
//     queryType: string;
//     firstSeen: string;
//     lastSeen: string;
//     totalRecords: number;
//     results: Results[];
// }

// export interface Results {
//     firstSeen: string;
//     lastSeen: string;
//     source: string[];
//     value: string;
//     collected: string;
//     recordType: string;
//     resolve: string;
//     resolveType: string;
//     recordHash: string;
// }

// export interface IocRowProps {
//     t: any;
//     row: Ioc
//     index: number
//     showMore: ShowMoreState;
//     handleClick: (string) => void;
//     theme: any;
// }

// /**
//  * The AI team had provided a results key with more information on the row.
//  * This key was removed at the last minute
//  */
// export default function IocRow({t, row, index, showMore, handleClick, theme}: IocRowProps) {

//     return(<>
//         <TableRow
//             key={`ioc-row-${index}`}
//             sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
//         >
//             <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{row.source}</TableCell>
//             <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{row.message.queryType}</TableCell>
//             <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{row.message.queryValue}</TableCell>
//             <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{row.message.totalRecords}</TableCell>
//             <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{row.message.lastSeen}</TableCell>
//             <TableCell onClick={() => handleClick(`ioc-row-${index}`)}>{row.message.firstSeen}</TableCell>
//         </TableRow>
//         {/* Render additional table row if clicked and additional info is to be shown */}
//         {showMore[`ioc-row-${index}`] && (
//             <TableRow
//                 key={`ioc-row-more-${index}`}
//                 sx={{ '&:last-child td, &:last-child th': { border: 0 }, padding: 0 }}
//             >
//                 {/* Render cells for additional info */}
//                 <TableCell colSpan={6} sx={{ padding: 0 }}>
//                     <TableContainer>
//                         <Table aria-label="flywheel-iocs-more">
//                             { 
//                                 row.message.results.map((resultItem, resultIndex) => (
//                                     <TableBody key={`ioc-row-more-${resultIndex}`} component={Paper} elevation={1} sx={{borderBottom: '1px solid rgba(81, 81, 81, 1)'}}>
//                                         <IOCMoreRow key={`ioc-row-more-${resultIndex}-1`} className="d-flex flex-row">
//                                             <IOCMoreCell>
//                                                 <span style={{color: theme.colors.textDisabledColor}}>{t("IOC_ROW.FIRST_SEEN")}</span>
//                                             </IOCMoreCell>
//                                             <IOCMoreCell>
//                                                 <span className="pt-1" style={{color: theme.colors.textColor, whiteSpace: 'pre-line'}}>{resultItem.firstSeen}</span>
//                                             </IOCMoreCell>
//                                         </IOCMoreRow>
//                                         <IOCMoreRow key={`ioc-row-more-${resultIndex}-2`} className="d-flex flex-row">
//                                             <IOCMoreCell>
//                                                 <span style={{color: theme.colors.textDisabledColor}}>{t("IOC_ROW.LAST_SEEN")}</span>
//                                             </IOCMoreCell>
//                                             <IOCMoreCell>
//                                                 <span className="pt-1" style={{color: theme.colors.textColor, whiteSpace: 'pre-line'}}>{resultItem.lastSeen}</span>
//                                             </IOCMoreCell>
//                                         </IOCMoreRow>
//                                         <IOCMoreRow key={`ioc-row-more-${resultIndex}-3`} className="d-flex flex-row">
//                                             <IOCMoreCell>
//                                                 <span style={{color: theme.colors.textDisabledColor}}>{t("IOC_ROW.SOURCE")}</span>
//                                             </IOCMoreCell>
//                                             <IOCMoreCell>
//                                                 <span className="pt-1" style={{color: theme.colors.textColor, whiteSpace: 'pre-line'}}>
//                                                     {resultItem.source.map((resultSourceItem, resultSourceIndex) => (
//                                                         <p key={`source-${resultSourceIndex}`}>{resultSourceItem}</p>
//                                                     ))}
//                                                 </span>
//                                             </IOCMoreCell>
//                                         </IOCMoreRow>
//                                         <IOCMoreRow key={`ioc-row-more-${resultIndex}-4`} className="d-flex flex-row">
//                                             <IOCMoreCell>
//                                                 <span style={{color: theme.colors.textDisabledColor}}>{t("IOC_ROW.VALUE")}</span>
//                                             </IOCMoreCell>
//                                             <IOCMoreCell>
//                                                 <span className="pt-1" style={{color: theme.colors.textColor, whiteSpace: 'pre-line'}}>{resultItem.value}</span>
//                                             </IOCMoreCell>
//                                         </IOCMoreRow>
//                                         <IOCMoreRow key={`ioc-row-more-${resultIndex}-5`} className="d-flex flex-row">
//                                             <IOCMoreCell>
//                                                 <span style={{color: theme.colors.textDisabledColor}}>{t("IOC_ROW.COLLECTED")}</span>
//                                             </IOCMoreCell>
//                                             <IOCMoreCell>
//                                                 <span className="pt-1" style={{color: theme.colors.textColor, whiteSpace: 'pre-line'}}>{resultItem.collected}</span>
//                                             </IOCMoreCell>
//                                         </IOCMoreRow>
//                                         <IOCMoreRow key={`ioc-row-more-${resultIndex}-6`} className="d-flex flex-row">
//                                             <IOCMoreCell>
//                                                 <span style={{color: theme.colors.textDisabledColor}}>{t("IOC_ROW.RECORD_TYPE")}</span>
//                                             </IOCMoreCell>
//                                             <IOCMoreCell>
//                                                 <span className="pt-1" style={{color: theme.colors.textColor, whiteSpace: 'pre-line'}}>{resultItem.recordType}</span>
//                                             </IOCMoreCell>
//                                         </IOCMoreRow>
//                                         <IOCMoreRow key={`ioc-row-more-${resultIndex}-7`} className="d-flex flex-row">
//                                             <IOCMoreCell>
//                                                 <span style={{color: theme.colors.textDisabledColor}}>{t("IOC_ROW.RESOLVE")}</span>
//                                             </IOCMoreCell>
//                                             <IOCMoreCell>
//                                                 <span className="pt-1" style={{color: theme.colors.textColor, whiteSpace: 'pre-line'}}>{resultItem.resolve}</span>
//                                             </IOCMoreCell>
//                                         </IOCMoreRow>
//                                         <IOCMoreRow key={`ioc-row-more-${resultIndex}-8`} className="d-flex flex-row">
//                                             <IOCMoreCell>
//                                                 <span style={{color: theme.colors.textDisabledColor}}>{t("IOC_ROW.RESOLVE_TYPE")}</span>
//                                             </IOCMoreCell>
//                                             <IOCMoreCell>
//                                                 <span className="pt-1" style={{color: theme.colors.textColor, whiteSpace: 'pre-line'}}>{resultItem.resolveType}</span>
//                                             </IOCMoreCell>
//                                         </IOCMoreRow>
//                                         <IOCMoreRow key={`ioc-row-more-${resultIndex}-9`} className="d-flex flex-row">
//                                             <IOCMoreCell>
//                                                 <span style={{color: theme.colors.textDisabledColor}}>{t("IOC_ROW.RECORD_HASH")}</span>
//                                             </IOCMoreCell>
//                                             <IOCMoreCell>
//                                                 <span className="pt-1" style={{color: theme.colors.textColor, whiteSpace: 'pre-line'}}>{resultItem.recordHash}</span>
//                                             </IOCMoreCell>
//                                         </IOCMoreRow>
//                                     </TableBody>
//                                 ))
//                             }
//                         </Table>
//                     </TableContainer>
//                 </TableCell>
//             </TableRow>
//         )}
//     </>);
// }
